"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBannerContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var StyledBannerContainer = exports.StyledBannerContainer = _styledComponents.default.div.withConfig({
  displayName: "styled__StyledBannerContainer",
  componentId: "sc-cx3fm7-0"
})(["background-color:", ";width:100%;padding:0.5rem 1rem;z-index:2;display:flex;justify-content:space-between;"], _colors.default.grey05);